export enum UserServiceType {
  FETCH_USER_DATA = 'FETCH_USER_DATA',
  FETCH_USER_DATA_ERROR = 'FETCH_USER_DATA_ERROR',
  FETCH_USER_DATA_SUCCESS = 'FETCH_USER_DATA_SUCCESS',
  SUBMIT_LOGIN_FORM = 'SUBMIT_LOGIN_FORM',
  SUBMIT_LOGIN_FORM_SUCCESS = 'SUBMIT_LOGIN_FORM_SUCCESS',
  SUBMIT_LOGIN_FORM_FAILED = 'SUBMIT_LOGIN_FORM_FAILED'
}

export interface UserServiceResponseInterface {
  id: string
  externalId: string
  externalIdV2: string
  realm: {
    id: number
  }
  firstName: string
  email: string
  lastName: string
  timeZone: string
  realmUserId: string
  jobTitle: string
  level: string
  companyName: string
  companySize: string
  telephone: string
  industry: string
  country: string
  stateRegion: string
  roles: string[]
  photoId: string
  preAuth: string
}
